import { useQuery } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";

export interface MembershipCancellationStatus {
  hasPendingCancellationRequest: boolean;
}

export function useGetMembershipCancellationStatus(enabled = true) {
  return useQuery({
    queryKey: ["membership-cancellation-status"],
    enabled,
    queryFn: async () => {
      const res = await axiosInstance.get<MembershipCancellationStatus>(
        getAPIURL("/MembershipCancellation/status")
      );
      return res.data;
    },
  });
}
